import React from "react";
import ContentLoader from "react-content-loader";
import createMemo from "@src/static/hooks/createMemo";
import {getCookie} from '@utils/common'
const renderLoadComponent = (props: any) => {
    return props.loading === false ? (
        <React.Fragment>{props.children}</React.Fragment>
    ) : (
        <ContentLoader
            height={640}
            width={400}
            speed={1}
            primaryColor={getCookie('zwzt_night') == 1 ? '#2B2A34' : '#f3f3f3'}
            secondaryColor={getCookie('zwzt_night') == 1 ? '#2B2A34' : '#ecebeb'}
        >
            <rect x="40" y="40" rx="5" ry="5" width="320" height="82" />
            <rect x="130" y="152" rx="5" ry="5" width="140" height="10" />

            <rect x="40" y="210" rx="4" ry="4" width="320" height="15" />
            <rect x="40" y="240" rx="4" ry="4" width="320" height="15" />
            <rect x="40" y="270" rx="4" ry="4" width="320" height="15" />
            <rect x="40" y="300" rx="4" ry="4" width="320" height="15" />

            <rect x="40" y="330" rx="4" ry="4" width="320" height="15" />
            <rect x="40" y="360" rx="4" ry="4" width="320" height="15" />
            <rect x="40" y="390" rx="4" ry="4" width="320" height="15" />
            <rect x="40" y="420" rx="4" ry="4" width="320" height="15" />
            <rect x="40" y="450" rx="4" ry="4" width="320" height="15" />
            <rect x="40" y="480" rx="4" ry="4" width="320" height="15" />

            <rect x="40" y="510" rx="4" ry="4" width="320" height="15" />
            <rect x="40" y="540" rx="4" ry="4" width="320" height="15" />
            <rect x="40" y="570" rx="4" ry="4" width="320" height="15" />
            <rect x="40" y="600" rx="4" ry="4" width="320" height="15" />
        </ContentLoader>

    );
};

export default createMemo(renderLoadComponent);
